import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import React from 'react'


interface IButton extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: "primary" | "secondary";
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  isLoading?: boolean;
}

const Button: React.FC<IButton> = ({ children, variant = "primary", onClick, disabled, className, isLoading }) => {

  const base = "inline-flex items-center justify-center text-nowrap w-full text-sm md:text-[15px] font-medium tracking-tight px-6 py-3 rounded-xl transition-all duration-200 ease-out focus:outline-none focus:ring-2 focus:ring-blue/30";

  const variantClass =
    variant === "primary"
      ? "bg-blue text-white hover:bg-[#3F86C2] hover:shadow-md active:scale-[0.98]"
      : "bg-white text-lightBlack border border-gray-200 hover:border-blue hover:text-blue active:scale-[0.98]";

  return (
    <button
      disabled={disabled}
      className={clsx(base, variantClass, className, disabled && "opacity-60 cursor-not-allowed pointer-events-none")}
      onClick={onClick}
    >
      {isLoading ? <FontAwesomeIcon icon={faSpinner} spin /> : children}
    </button>
  )
}

export default Button
